import { useTranslation } from 'react-i18next';
import Modal from '../../components/shared/Modal/Modal';
import styles from './app-evaluation-wizard.module.scss';

type Props = {
  onStay: () => void;
  onLeave: () => void;
};

const LeaveWizardModal = ({ onStay, onLeave }: Props) => {
  const [t] = useTranslation('evaluations');
  return (
    <Modal
      show
      setShow={onStay}
      onCancelButtonClick={onStay}
      cancelButtonText={t('wizard.stay', 'Stanna kvar')}
      title={t('wizard.leaveTitle', 'Lämna guiden?')}
      buttonInfo={{ label: t('wizard.leaveConfirm', 'Lämna guiden'), action: onLeave }}
    >
      <p className={styles.intro}>{t('wizard.leaveText', 'Det du har fyllt i sparas inte.')}</p>
    </Modal>
  );
};

export default LeaveWizardModal;
